import React from "react";
import {
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "./ui/pagination";

const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  // Function to generate pagination items
  const renderPaginationItems = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <PaginationItem key={i}>
          <PaginationLink
            href="#"
            isActive={i === currentPage}
            onClick={(e) => handlePageChange(i, e)}
          >
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return pages;
  };

  return (
    <PaginationContent>
      <PaginationItem>
        <PaginationPrevious
          href="#"
          onClick={(e) => handlePageChange(currentPage - 1, e)}
          disabled={currentPage === 1} // Disable if on the first page
        />
      </PaginationItem>
      {renderPaginationItems()}
      {totalPages > 5 && (
        <PaginationItem>
          <PaginationEllipsis />
        </PaginationItem>
      )}
      <PaginationItem>
        <PaginationNext
          href="#"
          onClick={(e) => handlePageChange(currentPage + 1, e)}
          disabled={currentPage === totalPages} // Disable if on the last page
        />
      </PaginationItem>
    </PaginationContent>
  );
};

export default Pagination;
